export const privateHealthClaimsRoutes = {
  processing: {
    path: '/claims/private-health/policy/:policyId/processing',
  },
  submitted: {
    path: '/claims/private-health/policy/:policyId/submitted',
  },
};
